window.addEventListener('DOMContentLoaded', function () {
    var $sizeGuideModal = document.getElementById('sizeGuideModal'),
        $sizeGuide = document.getElementById('sizeGuide'),
        $sizeGuideClose = document.getElementById('sizeGuideClose'),
        $sizeGuideOverlay = $sizeGuideModal ? $sizeGuideModal.querySelector('.overlay') : null;

    var sizeGuideBtnIds = ['sizeGuideBtn', 'sizeGuideBtn-variant', 'sizeGuideBtn-customize'];

    if ($sizeGuideModal && $sizeGuideOverlay) {
        sizeGuideBtnIds.forEach(function (id) {
            var btn = document.getElementById(id);
            if (btn) btn.onclick = toggleSizeGuideModal;
        });

        if ($sizeGuideClose) $sizeGuideClose.onclick = toggleSizeGuideModal;
        $sizeGuideOverlay.onclick = toggleSizeGuideModal;
    }

    function toggleSizeGuideModal (event) {
        if (!$sizeGuideModal.classList.contains('hidden')) {
            $sizeGuide.classList.toggle('show');
            setTimeout(() => {
                $sizeGuideModal.classList.toggle('hidden');
            }, 300);
        } else {
            $sizeGuideModal.classList.toggle('hidden');
            setTimeout(() => {
               $sizeGuide.classList.toggle('show');
            }, 300);
        }
    }

});